module.exports = __webpack_public_path__ + "img/mbanner_playstation.3f9a320b.png";